import {
  InsightsFilterHook,
  convertClientFilterToErrorInsightsFilter,
  convertClientFilterToStatsFilter,
} from 'src/hooks/useInsightsFilter';
import { ErrorInsightsListFilterInput } from 'src/lib/graphqlTypes/types';
import { isMinLengthArray } from 'src/lib/isMinLengthArray';

export function buildErrorFiltersForListQuery(
  routeParams: InsightsFilterHook['routeParams'],
): ErrorInsightsListFilterInput {
  return {
    ...(routeParams.query ? { operationId: routeParams.query } : {}),
    ...(Array.isArray(routeParams.errorsPathFilter) &&
    isMinLengthArray(1, routeParams.errorsPathFilter)
      ? { path: routeParams.errorsPathFilter[0] }
      : {}), // TODO(tim): support path in FederatedErrorStatsFilterIn
    in: {
      ...(Array.isArray(routeParams.errorsServiceFilter)
        ? { serviceOrAgent: routeParams.errorsServiceFilter }
        : {}),
      ...(Array.isArray(routeParams.errorsCodeFilter)
        ? { code: routeParams.errorsCodeFilter }
        : {}),
    },
    ...(routeParams.clients
      ? {
          or: convertClientFilterToErrorInsightsFilter(routeParams.clients),
        }
      : {}),
  };
}

export function buildErrorFiltersForLegendQuery(
  routeParams: InsightsFilterHook['routeParams'],
): ErrorInsightsListFilterInput {
  return {
    ...(routeParams.query ? { operationId: routeParams.query } : {}),
    ...(routeParams.clients
      ? {
          or: convertClientFilterToErrorInsightsFilter(routeParams.clients),
        }
      : {}),
  };
}

export function buildErrorFiltersForStatsWindowQuery(
  routeParams: InsightsFilterHook['routeParams'],
): ErrorInsightsListFilterInput {
  return {
    ...(routeParams.query ? { queryId: routeParams.query } : {}),
    ...(routeParams.clients
      ? {
          or: convertClientFilterToStatsFilter(routeParams.clients),
        }
      : {}),
  };
}
